import React from 'react'

interface ProductTypeIconProps {
  color?: string
  size?: number | string
  className?: string
}

export const ProductTypeIcon: React.FC<ProductTypeIconProps> = ({
  color = 'currentColor',
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Tag shape */}
    <path
      d="M20.59 13.41L13.42 6.24C13.2343 6.05431 13.0007 5.96191 12.76 5.96H4C3.46957 5.96 2.96086 6.17071 2.58579 6.54579C2.21071 6.92086 2 7.42957 2 7.96V16.96C2 17.4904 2.21071 18.0001 2.58579 18.3752C2.96086 18.7503 3.46957 18.961 4 18.961H12.76C13.0007 18.9591 13.2343 18.8667 13.42 18.681L20.59 11.51C21.3663 10.7337 21.3663 9.4663 20.59 8.69L15.31 3.41C14.5337 2.63366 13.2663 2.63366 12.49 3.41L5.32 10.58"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* Small circle for tag hole */}
    <circle cx="7" cy="7" r="1.5" fill={color} />
  </svg>
)

export default ProductTypeIcon
